/**
 * Header account — guest: visible icon opens Shopify account sheet; signed-in: link + hover menu.
 */
(function () {
  'use strict';

  function normalizeNavUrl(url) {
    if (url == null) return '';
    var u = String(url).trim();
    if (!u || u === '#') return '';
    if (u.indexOf('shopify://pages/') === 0) {
      return '/pages/' + u.slice('shopify://pages/'.length).split('?')[0];
    }
    return u;
  }

  function loginUrl() {
    var root = document.querySelector('[data-header-account]');
    var fromRoot = root && root.getAttribute('data-login-url');
    if (fromRoot) return normalizeNavUrl(fromRoot);
    if (window.routes && window.routes.account_login_url) {
      return normalizeNavUrl(window.routes.account_login_url);
    }
    return '/account/login';
  }

  function getSheetHost(root) {
    return (
      (root && root.querySelector('[data-header-account-sheet]')) ||
      document.querySelector('shopify-account[data-header-account-sheet]')
    );
  }

  function hostLooksSignedOut(host) {
    if (!host || !host.shadowRoot) return null;
    if (host.shadowRoot.querySelector('button[part="signed-out-avatar"]')) return true;
    if (
      host.shadowRoot.querySelector('button[part="avatar"]') ||
      host.shadowRoot.querySelector('[part="signed-in-avatar"]')
    ) {
      return false;
    }
    return null;
  }

  function readToken() {
    if (window.RaysLoyalty && window.RaysLoyalty.syncStorefrontTokenFromWebComponents) {
      try {
        window.RaysLoyalty.syncStorefrontTokenFromWebComponents();
      } catch (e) {}
    }
    if (window.RaysLoyalty && window.RaysLoyalty.getStorefrontCustomerAccessToken) {
      try {
        var t = window.RaysLoyalty.getStorefrontCustomerAccessToken();
        if (t) return t;
      } catch (e) {}
    }
    var key =
      window.__RAYS_STOREFRONT__ &&
      window.__RAYS_STOREFRONT__.customerTokenStorageKey;
    if (!key) return '';
    try {
      return String(sessionStorage.getItem(key) || '').trim();
    } catch (e2) {
      return '';
    }
  }

  function detectSignedInForRoot(root) {
    if (!root) return false;
    if (root.getAttribute('data-liquid-signed-in') === 'true') return true;

    var sheet = getSheetHost(root);
    var guestTrigger = root.querySelector('.js-header-account-guest-trigger');

    if (sheet && sheet.shadowRoot) {
      var sheetState = hostLooksSignedOut(sheet);
      if (sheetState === true) return false;
      if (sheetState === false) return true;
    }

    if (guestTrigger && guestTrigger.shadowRoot) {
      var style = window.getComputedStyle(guestTrigger);
      if (style.display !== 'none' && style.visibility !== 'hidden') {
        var guestState = hostLooksSignedOut(guestTrigger);
        if (guestState === true) return false;
        if (guestState === false) return true;
      }
    }

    if (readToken()) {
      if (sheet && sheet.shadowRoot) {
        var tokenSheetState = hostLooksSignedOut(sheet);
        if (tokenSheetState === true) return false;
        if (tokenSheetState === false) return true;
      }
      if (guestTrigger && guestTrigger.shadowRoot) {
        var tokenGuestState = hostLooksSignedOut(guestTrigger);
        if (tokenGuestState === true) return false;
        if (tokenGuestState === false) return true;
      }
      /* Stale storage token: do not override Liquid guest state before WC is ready. */
      return root.getAttribute('data-liquid-signed-in') === 'true';
    }

    return false;
  }

  function openAccountSheetFromHost(host) {
    if (!host || !host.shadowRoot) return false;
    var btn =
      host.shadowRoot.querySelector('button[part="signed-out-avatar"]') ||
      host.shadowRoot.querySelector('[part="signed-out-avatar"]');
    if (!btn || typeof btn.click !== 'function') return false;
    try {
      host.focus({ preventScroll: true });
    } catch (f) {}
    btn.click();
    return true;
  }

  function openAccountSheet() {
    if (window.RaysLoyalty && typeof window.RaysLoyalty.openAccountSheet === 'function') {
      return window.RaysLoyalty.openAccountSheet({ fallback: true, fallbackUrl: loginUrl() });
    }
    var root =
      document.querySelector('[data-header-account][data-variant="header"]') ||
      document.querySelector('[data-header-account]');
    var sheet = getSheetHost(root);
    if (sheet && openAccountSheetFromHost(sheet)) return true;
    window.location.assign(loginUrl());
    return false;
  }

  function loggedInUrlForRoot(root) {
    if (!root) return '';
    var fromData = normalizeNavUrl(root.getAttribute('data-logged-in-url'));
    if (fromData) return fromData;
    if (window.routes && window.routes.account_url) {
      return normalizeNavUrl(window.routes.account_url);
    }
    return '';
  }

  function applyAuthState(root) {
    if (!root) return;
    var signedIn = detectSignedInForRoot(root);
    root.classList.toggle('header-account--signed-in', signedIn);
    root.classList.toggle('header-account--guest', !signedIn);

    if (signedIn && root.getAttribute('data-rays-auth-emitted') !== '1') {
      root.setAttribute('data-rays-auth-emitted', '1');
      try {
        document.dispatchEvent(new CustomEvent('rays-loyalty:storefront-auth'));
      } catch (authEv) {}
    } else if (!signedIn) {
      root.setAttribute('data-rays-auth-emitted', '0');
    }

    var linkTrigger = root.querySelector('.js-header-account-trigger');
    var navUrl = loggedInUrlForRoot(root);
    var drawerLinks = root.querySelector('[data-header-account-drawer-links]');

    if (linkTrigger) {
      if (signedIn) {
        linkTrigger.removeAttribute('aria-hidden');
        linkTrigger.removeAttribute('tabindex');
        if (navUrl) {
          linkTrigger.setAttribute('href', navUrl);
        }
      } else {
        linkTrigger.setAttribute('href', '#');
        linkTrigger.setAttribute('tabindex', '-1');
        linkTrigger.setAttribute('aria-hidden', 'true');
      }
    }

    if (drawerLinks) {
      if (signedIn && root.getAttribute('data-hover-menu') === 'true') {
        drawerLinks.removeAttribute('hidden');
      } else {
        drawerLinks.setAttribute('hidden', '');
      }
    }
  }

  function navigateSignedIn(root, linkTrigger) {
    var url = loggedInUrlForRoot(root);
    if (!url && linkTrigger) {
      url = normalizeNavUrl(linkTrigger.getAttribute('href'));
    }
    if (url) {
      window.location.assign(url);
      return true;
    }
    if (window.routes && window.routes.account_url) {
      window.location.assign(normalizeNavUrl(window.routes.account_url));
      return true;
    }
    return false;
  }

  function bindHoverMenu(root) {
    if (root.dataset.hoverMenuBound === '1') return;
    var wrap = root.querySelector('.header-account__wrap');
    var dropdown = root.querySelector('[data-header-account-dropdown]');
    if (!wrap || !dropdown) return;
    root.dataset.hoverMenuBound = '1';

    var hideTimer = null;
    function showMenu() {
      if (!root.classList.contains('header-account--signed-in')) return;
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      dropdown.classList.add('is-open');
    }
    function hideMenuDelayed() {
      hideTimer = setTimeout(function () {
        dropdown.classList.remove('is-open');
        hideTimer = null;
      }, 320);
    }

    wrap.addEventListener('mouseenter', showMenu);
    wrap.addEventListener('mouseleave', hideMenuDelayed);
    dropdown.addEventListener('mouseenter', showMenu);
    dropdown.addEventListener('mouseleave', hideMenuDelayed);
  }

  function bindRoot(root) {
    if (!root || root.dataset.headerAccountBound) return;
    root.dataset.headerAccountBound = '1';

    var linkTrigger = root.querySelector('.js-header-account-trigger');
    if (linkTrigger) {
      linkTrigger.addEventListener('click', function (e) {
        applyAuthState(root);
        if (!root.classList.contains('header-account--signed-in')) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        navigateSignedIn(root, linkTrigger);
      });
    }

    bindHoverMenu(root);
    applyAuthState(root);
  }

  function refreshAll() {
    document.querySelectorAll('[data-header-account]').forEach(applyAuthState);
  }

  function watchHosts() {
    document.querySelectorAll('shopify-account').forEach(function (host) {
      if (host.dataset.headerAccountWatched) return;
      host.dataset.headerAccountWatched = '1';
      host.addEventListener('close', function () {
        window.setTimeout(refreshAll, 150);
      });
      host.addEventListener('open', function () {
        window.setTimeout(refreshAll, 150);
      });
      if (host.shadowRoot) {
        var obs = new MutationObserver(function () {
          refreshAll();
        });
        obs.observe(host, { childList: true, subtree: true, attributes: true });
      }
    });
  }

  function isShopifyAccountDefined() {
    return !!(
      window.customElements &&
      typeof window.customElements.get === 'function' &&
      window.customElements.get('shopify-account')
    );
  }

  function whenShopifyAccountReady(cb) {
    if (isShopifyAccountDefined()) {
      cb();
      return;
    }
    var done = false;
    function run() {
      if (done) return;
      done = true;
      cb();
    }
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      var timer = window.setTimeout(run, 400);
      window.customElements
        .whenDefined('shopify-account')
        .then(function () {
          window.clearTimeout(timer);
          run();
        })
        .catch(function () {
          window.clearTimeout(timer);
          run();
        });
      return;
    }
    run();
  }

  function init() {
    whenShopifyAccountReady(function () {
      document.querySelectorAll('[data-header-account]').forEach(bindRoot);
      watchHosts();
      refreshAll();
      window.setTimeout(refreshAll, 500);
      window.setTimeout(refreshAll, 1500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.HeaderAccount = {
    openSheet: openAccountSheet,
    refresh: refreshAll,
    isSignedIn: function () {
      var roots = document.querySelectorAll('[data-header-account]');
      for (var i = 0; i < roots.length; i++) {
        if (detectSignedInForRoot(roots[i])) return true;
      }
      return false;
    },
  };
})();
